export const checkFreeTrialParamInUrl = () => {
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has("freeTrial")) return true;
  return false;
};
